import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.group('💥 React Error Boundary Caught Error');
    console.error('Error:', error);
    console.error('Error Info:', errorInfo);
    console.error('Component Stack:', errorInfo.componentStack);
    console.error('Error Stack:', error.stack);
    console.groupEnd();

    this.setState({
      error: error,
      errorInfo: errorInfo
    });

    // Log to external service if needed
    if (window.posthog) {
      window.posthog.capture('app_error', {
        error: error.toString(),
        component_stack: errorInfo.componentStack,
        error_stack: error.stack,
        url: window.location.href
      });
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          padding: '20px',
          margin: '20px',
          border: '1px solid #ff6b6b',
          borderRadius: '8px',
          backgroundColor: '#ffe6e6',
          fontFamily: 'Arial, sans-serif'
        }}>
          <h2 style={{ color: '#d63031', marginBottom: '16px' }}>
            🚨 Something went wrong
          </h2>
          <p style={{ marginBottom: '16px', color: '#2d3436' }}>
            The Rally App encountered an error. Please check the browser console for details.
          </p>
          
          <div style={{ marginBottom: '16px' }}>
            <button 
              onClick={() => window.location.reload()}
              style={{
                padding: '8px 16px',
                marginRight: '8px',
                backgroundColor: '#0984e3',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              🔄 Reload Page
            </button>
            
            <button 
              onClick={() => {
                localStorage.clear();
                sessionStorage.clear();
                window.location.reload();
              }}
              style={{
                padding: '8px 16px',
                backgroundColor: '#e17055',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              🧹 Clear Storage & Reload
            </button>
          </div>

          <details style={{ marginTop: '16px' }}>
            <summary style={{ cursor: 'pointer', fontWeight: 'bold' }}>
              Technical Details (Click to expand)
            </summary>
            <pre style={{
              backgroundColor: '#f8f9fa',
              padding: '12px',
              borderRadius: '4px',
              fontSize: '12px',
              overflow: 'auto',
              marginTop: '8px',
              border: '1px solid #dee2e6'
            }}>
              <strong>Error:</strong> {this.state.error && this.state.error.toString()}{'\n'}
              <strong>Component Stack:</strong> {this.state.errorInfo.componentStack}
            </pre>
          </details>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;